import { render, staticRenderFns } from "./chooseDept.vue?vue&type=template&id=20ebdccc&scoped=true"
import script from "./chooseDept.vue?vue&type=script&lang=js"
export * from "./chooseDept.vue?vue&type=script&lang=js"
import style0 from "./chooseDept.vue?vue&type=style&index=0&id=20ebdccc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ebdccc",
  null
  
)

export default component.exports